import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import sidebarImage from '../assets/signup_1.png'; 

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPwd] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validEmail = (e) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(e.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!validEmail(email)) {
      setError("Please enter a valid email address");
      setIsLoading(false);
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      setIsLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
        setIsLoading(false);
        setError("You have been added to the waitlist");
    }, 1500);
  };

  return (
    <>
      <style>{`
        /* Reset & Base */
        * { box-sizing: border-box; }
        
        .container {
          min-height: 100vh;
          display: flex;
          font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
          background-color: #fff;
        }

        /* --- LEFT PANE (Content) --- */
        .left-pane {
          flex: 1;
          background: #fff;
          display: flex;
          flex-direction: column;
          padding: 40px 60px;
          position: relative;
          max-width: 100%;
        }

        /* --- RIGHT PANE (Image) --- */
        .right-pane {
          flex: 1;
          background-image: url(${sidebarImage});
          background-size: cover;
          background-position: center top;
          display: block; /* Default visible on desktop */
        }

        /* --- FORM AREA --- */
        .content-wrapper {
          width: 100%;
          max-width: 450px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1; 
        }

        .title {
          font-size: 2.2rem;
          font-weight: 500;
          margin-bottom: 2rem;
          color: #000;
          text-transform: uppercase;
          line-height: 1.1;
        }

        .signup-form {
          display: flex;
          flex-direction: column;
          gap: 1.2rem;
        }

        .input-field {
          padding: 1rem;
          font-size: 1rem;
          border: 1px solid #e0e0e0;
          border-radius: 2px;
          outline: none;
          background: #fff;
          color: #333;
          width: 100%;
        }
        .input-field:focus { border-color: #999; }
        .input-field::placeholder { color: #aaa; text-transform: uppercase; }

        .submit-btn {
          margin-top: 1rem;
          padding: 1.2rem;
          font-size: 1rem;
          font-weight: 700;
          color: #fff;
          background-color: #C32F27; /* Darker red matching Figma */
          border: none;
          border-radius: 2px;
          cursor: pointer;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          width: 100%;
        }

        .login-text {
          margin-top: 1.5rem;
          color: #666;
          font-size: 1rem;
        }
        .login-link {
          color: #000;
          font-weight: 600;
          text-decoration: none;
          margin-left: 5px;
          cursor: pointer;
        }

        .error-msg {
          color: #C32F27;
          margin-top: 1rem;
          font-size: 0.9rem;
        }

        /* --- FEATURES FOOTER --- */
        .features-container {
          margin-top: auto;
          padding-top: 2rem;
          display: flex;
          justify-content: space-between;
          width: 100%;
          max-width: 450px;
          margin-left: auto;
          margin-right: auto;
        }
        .feature-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 0.8rem;
          width: 30%;
        }
        .feature-circle {
          width: 54px;
          height: 54px;
          border-radius: 50%;
          border: 1px solid #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #111;
          background: #fff;
        }
        .feature-text {
          font-size: 0.85rem;
          color: #111;
          line-height: 1.2;
        }

        /* --- MOBILE RESPONSIVENESS --- */
        @media only screen and (max-width: 900px) {
          .container {
            flex-direction: column;
          }
          
          /* Force hide the right image pane */
          .right-pane {
            display: none !important;
            width: 0;
            height: 0;
          }

          /* Adjust left pane to take full width */
          .left-pane {
            flex: 1;
            width: 100%;
            /* Reduced padding to maximize vertical space */
            padding: 30px 24px 20px 24px; 
          }
          
          /* Adjust Title Size */
          .title {
            font-size: 1.8rem;
            margin-bottom: 24px;
            /* Since nav is gone, ensure top margin isn't too huge */
            margin-top: 0; 
          }
          
          .features-container {
            padding-top: 1.5rem; 
            margin-bottom: 0.5rem;
          }
          
          /* Form Inputs */
          .input-field {
            padding: 0.9rem;
          }
        }
      `}</style>

      <div className="container">
        {/* LEFT PANE (Content) */}
        <div className="left-pane">
          
          {/* NAV SECTION REMOVED COMPLETELY */}

          {/* Form Content */}
          <div className="content-wrapper">
            <h2 className="title">Create a QuickFit Account</h2>
            
            <form onSubmit={handleSubmit} className="signup-form">
              <input
                type="email"
                className="input-field"
                placeholder="EMAIL"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                className="input-field"
                placeholder="PASSWORD"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={8}
                required
              />
              <input
                type="password"
                className="input-field"
                placeholder="CONFIRM PASSWORD"
                value={confirmPassword}
                onChange={(e) => setConfirmPwd(e.target.value)}
                minLength={8}
                required
              />

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? "SIGNING UP..." : "SIGN UP"}
              </button>
            </form>

            {error && <p className="error-msg">{error}</p>}

            <div className="login-text">
              Already have an account? 
              <span className="login-link" onClick={() => navigate('/login')}>Sign In</span>
            </div>
          </div>

          {/* Bottom Features */}
          <div className="features-container">
            <div className="feature-item">
              <div className="feature-circle">
                 {/* Percent Icon */}
                 <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                   <path d="M19 5L5 19M5.5 5.5H5.51M18.5 18.5H18.51" strokeLinecap="round" strokeLinejoin="round"/>
                   <circle cx="6.5" cy="6.5" r="2.5" />
                   <circle cx="17.5" cy="17.5" r="2.5" />
                 </svg>
              </div>
              <span className="feature-text">Exclusive<br/>Discounts</span>
            </div>
            
            <div className="feature-item">
              <div className="feature-circle">
                {/* Hanger Icon */}
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                   <path d="M12 3a4 4 0 0 0-4 4v1H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2V7a4 4 0 0 0-4-4z" />
                </svg>
              </div>
              <span className="feature-text">Personalized<br/>Style</span>
            </div>

            <div className="feature-item">
              <div className="feature-circle">
                {/* Truck Icon */}
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="1" y="3" width="15" height="13" rx="2" ry="2"></rect>
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                  <circle cx="5.5" cy="18.5" r="2.5"></circle>
                  <circle cx="18.5" cy="18.5" r="2.5"></circle>
                </svg>
              </div>
              <span className="feature-text">Fast<br/>Delivery</span>
            </div>
          </div>

        </div>

        {/* RIGHT PANE (Hidden on Mobile) */}
        <div className="right-pane"></div>
      </div>
    </>
  );
};

export default Signup;